import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import { Checkbox, Divider} from 'antd';
import {Container, Row, Col, Modal } from 'react-bootstrap';

// import CookieConsent from 'react-cookie-consent';
import Cookies from 'js-cookie'

import './cookie.css';

const Cookie = () => {
  const [acceptCookies, setAcceptCookies] = useState(Cookies.get('hcb-cookie'));
  const [visible, setVisible] = useState(false);
  const [analytics, setAnalytics] = useState(true);
  const [marketing, setMarketing] = useState(true);


  function acceptAllCookies() {
    setAcceptCookies(true);
    Cookies.set('hcb-cookie', true, { expires: 90 });
    Cookies.set('hcb-analytics', true);
    Cookies.set('hcb-marketing', true);
  }

  function rejectAllCookies() {
    setAcceptCookies(true);
    Cookies.set('hcb-cookie', true, { expires: 90 });
    Cookies.set('hcb-analytics', false);
    Cookies.set('hcb-marketing', false);
  }

  function configCookies() {
    console.log('config cookies')
  }

  function saveChanges() {
    setAcceptCookies(true);
    Cookies.set('hcb-cookie', true, { expires: 90 });
    Cookies.set('hcb-marketing', marketing);
    Cookies.set('hcb-analytics', analytics);
    setVisible(false);
  }

  function handleChange(e, type) {
    if (type === 'marketing') {
      setMarketing(e);
    } else {
      setAnalytics(e);
    }
  }

  return (
    <Container
      className="bg-white fixed-bottom cookie position-relative"
      fluid
      style={{zIndex: 1000}}
    >
      <div className="px-3 px-md-5 py-4 floating-shadow" style={{
        display: acceptCookies ? 'none' : 'block',
        position: 'fixed',
        left: 0,
        bottom: 0,
        width: '100%',
        background: 'rgba(255, 255, 255, 0.95)',
      }}>
        <div>
          <h3 className="bold-title-hyundai f-responsive-14">Configuración de cookies</h3>
          <p className='parrafo-hyundai pb-3 pb-md-0 text-left'>
            {/* Para Hyundai es importante adaptarse a tus gustos y preferencias, para ello
            utilizamos cookies propias y de terceros para diferenciar su experiencia de las de otros usuarios, con fines
            analíticos y para mostrarle publicidad personalizada en base a un perfil elaborado a partir de sus hábitos
            de navegación. Puedes configurar las cookies o aceptarlas todas. Este banner se mantendrá activo hasta que
            ejecutes una de las dos opciones. Para más información consulta nuestra  */}
            Con el objetivo de entregar la mejor experiencia durante su navegación, este sitio utiliza cookies.
            <br /> Para más detalles haz <Link to={'/politicas'}><u style={{ color: '#46ABF2' }}> Click aquí </u></Link>
            {/* <a onClick={() => window.location.href = '/politicas'} style={{color: '#46ABF2'}}>Política de Cookies</a> */}
            </p>
        </div>
        <div className='row'>
          <div className='col-12 col-md-4 pr-md-5'>
            <button onClick={() => setVisible(!visible)} className='btn-secundario w-100 font-btn my-2 py-1 py-md-0'>Configurar cookies</button>
          </div>
          <div className='col-12 col-md-4 px-md-5'>
            <button onClick={rejectAllCookies} className='btn-secundario w-100 font-btn my-2 py-1 py-md-0'>Rechazar todas las cookies</button>
          </div>
          <div className='col-12 col-md-4 pl-md-5'>
            <button onClick={acceptAllCookies} className='btn-primario w-100 font-ver font-btn my-2 py-1 py-md-0'>Aceptar todas las cookies</button>
          </div>
        </div>
      </div>
      <Modal
        className="modal-cookie"
        centered
        // footer={null}
        fullscreen={'sm-down'}
        size="xl"
        show={visible}
        // onHide={() => setVisible(false)}
        onHide={() => setVisible(false)}
        // width={1000}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="border-0 pl-4 p-md-4">
          <h3 className="bold-title-hyundai f-responsive-18 pt-1 mb-0">Configurar Cookies</h3>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <div className="container" >
            <Row>
              <Col xs={'auto'} className="px-1 px-md-3"><Checkbox checked disabled/></Col>
              <Col className="px-1 pl-md-3 pr-md-5">
                <h5 className="bold-title-hyundai f-responsive-12">Técnicas y estrictamente necesarias (obligatorias)</h5>
                <p className='parrafo-hyundai f-responsive-12' style={{ textAlign: 'justify' }}>Son aquellas que resultan necesarias para el buen funcionamiento de la página web o para suministrar un
                  servicio solicitado por el usuario respectivamente. En este sentido se consideran como necesarias y por
                  tanto no sujetas a consentimiento informado aquellas cookies de personalización o preferencias que
                  permiten recordar información para que el usuario acceda al servicio con determinadas características
                  que
                  puedan diferenciar su experiencia de la de otros usuarios, como por ejemplo serían el idioma o el número
                  de resultados a mostrar en una búsqueda.</p>
                <Divider/>
              </Col>
            </Row>
            <Row>
              <Col xs={'auto'} className="px-1 px-md-3"><Checkbox checked={analytics} onChange={e => handleChange(e.target.checked, 'analytics')}/></Col>
              <Col className="px-1 pl-md-3 pr-md-5">
                <h5 className="bold-title-hyundai f-responsive-12">Analíticas</h5>
                <p className='parrafo-hyundai f-responsive-12' style={{ textAlign: 'justify' }}>Permiten reconocer y contabilizar el número de visitantes de nuestro sitio web, así como analizar su
                  navegación y uso del mismo. Permitiendo realizar perfiles de navegación. No recopilan información de
                  carácter personal. Entre estas se encuentran las cookies de Google Analitics, servicio de análisis web
                  facilitado por Google, Inc. Para obtener más información sobre la como Google recoge y trata los datos
                  pinche en <a href="https://policies.google.com/privacy?hl=es" rel="noreferrer"
                              target='_blank'>https://policies.google.com/privacy?hl=es</a></p>
                <Divider/>
              </Col>
            </Row>
            <Row>
              <Col xs={'auto'} className="px-1 px-md-3"><Checkbox checked={marketing} onChange={e => handleChange(e.target.checked, 'marketing')}/></Col>
              <Col className="px-1 pl-md-3 pr-md-5">
                <h5 className="bold-title-hyundai f-responsive-12">Publicidad comportamental</h5>
                <p className='parrafo-hyundai f-responsive-12' style={{ textAlign: 'justify' }}>Estas cookies, propias o de terceros, almacenan información del comportamiento del usuario obtenida a
                  través de la observación continuada de sus hábitos de navegación (visitas repetidas a un sitio concreto,
                  interacciones, palabras clave, producción de contenidos en línea, etc.), permitiendo desarrollar un
                  perfil específico para mostrarle publicidad en función del mismo. </p>
                <p className='parrafo-hyundai f-responsive-12' style={{ textAlign: 'justify' }}>
                  Puede consultar nuestra política de cookies en cualquier momento <Link to={'/politicas'}><u style={{ color: '#46ABF2' }}>aquí</u></Link>.
                </p>
                <Divider/>
              </Col>
            </Row>
          </div>
          <div className='d-flex justify-content-end'>
            <button className='btn-primario font-ver font-btn my-2 px-5 py-1 py-md-0' onClick={saveChanges}>Guardar y aceptar</button>
          </div>
        </Modal.Body>
      </Modal>
      {/*<CookieConsent*/}
      {/*    location='bottom'*/}
      {/*    buttonText=" ACEPTAR TODAS LAS COOKIES"*/}
      {/*    cookieName="hcb_cookie"*/}
      {/*    enableDeclineButton*/}
      {/*    contentClasses='cookie-content'*/}
      {/*    buttonWrapperClasses='cookie-button-wrapper'*/}
      {/*    style={{*/}
      {/*        display: 'flex',*/}
      {/*        flexDirection: 'column',*/}
      {/*    }}*/}
      {/*    declineButtonText='RECHAZAR TODAS LAS COOKIES'*/}
      {/*    expires={150}*/}
      {/*>*/}
      {/*    <div>*/}
      {/*        <p className='parrafo-hyundai'>*/}
      {/*            Con el objetivo de entregar la mejor experiencia durante su navegación, este sitio utiliza cookies.*/}
      {/*            <br /> Para más detalles haz <a onClick={() => window.location.href = '/politicas'}><u style={{ color: '#46ABF2' }}> Click aquí </u></a>*/}
      {/*            <br />*/}
      {/*            <button className='mt-4'>Configurar cookies</button>*/}
      {/*        </p>*/}
      {/*    </div>*/}
      {/*</CookieConsent>*/}
    </Container>
  )
}

export default Cookie;
